export * from "./cargasdescargas"


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/consultaMovimientosCarga/list/index.tsx